module.exports = __webpack_public_path__ + "static/media/unicorn.1b09cc91.png";